import React, { useId } from 'react';

interface JamBoardPushpinDecorProps {
    accentColor: string;
}

/**
 * Simple pushpin: colored circle + metal line into the board (no wedge/tip shape).
 */
const JamBoardPushpinDecor: React.FC<JamBoardPushpinDecorProps> = ({
    accentColor,
}) => {
    const uid = useId().replace(/:/g, '');
    const headGradId = `jbp-head-${uid}`;

    const cx = 24;
    const cy = 16;
    const r = 10;
    const lineTop = cy + r;
    const lineBottom = 51;

    return (
        <svg
            viewBox="0 0 48 56"
            className="h-11 w-9 drop-shadow-[2px_3px_4px_rgba(0,0,0,0.2)]"
            aria-hidden
        >
            <defs>
                <linearGradient
                    id={headGradId}
                    x1="15%"
                    y1="10%"
                    x2="95%"
                    y2="85%"
                >
                    <stop offset="0%" stopColor="#ffffff" stopOpacity="0.22" />
                    <stop offset="42%" stopColor={accentColor} stopOpacity="1" />
                    <stop offset="100%" stopColor={accentColor} stopOpacity="1" />
                </linearGradient>
            </defs>
            <g transform={`rotate(-16 ${cx} ${lineBottom})`}>
                <ellipse
                    cx={cx}
                    cy={lineBottom + 0.5}
                    rx="6.5"
                    ry="2"
                    fill="rgba(0,0,0,0.12)"
                />
                {/* Needle: straight line into the card */}
                <line
                    x1={cx}
                    y1={lineTop}
                    x2={cx}
                    y2={lineBottom}
                    stroke="#64748b"
                    strokeWidth="5"
                    strokeLinecap="round"
                />
                {/* Head on top */}
                <circle
                    cx={cx}
                    cy={cy}
                    r={r}
                    fill={`url(#${headGradId})`}
                    stroke="#292524"
                    strokeWidth="0.6"
                />
            </g>
        </svg>
    );
};

export default JamBoardPushpinDecor;
